import React, { useEffect, useState } from "react";
import axios from "axios";

const monthOptions = Array.from({ length: 6 }, (_, i) => {
  const date = new Date();
  date.setMonth(date.getMonth() - (i + 1));
  return {
    label: date.toLocaleString("default", { month: "long", year: "numeric" }),
    value: i + 1, // months_ago = 1 (last month) to 6
  };
});

const ResearchDigestPage = () => {
  const [selectedMonth, setSelectedMonth] = useState(1); // Default to last month
  const [researchPapers, setResearchPapers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const BACKEND = process.env.REACT_APP_BACKEND_URL;

  const fetchDigest = async (monthsAgo) => {
    setLoading(true);
    setError(null);

    try {
      const response = await axios.get(`ece/faculty/faculty-research-digest`, {
        baseURL: BACKEND,
        params: {
          months_ago: monthsAgo,
        },
      });
      console.log("Response data:", response.data);
      setResearchPapers(response.data || []);
    } catch (err) {
      console.error("Failed to fetch digest:", err);
      setError("Failed to load research data. Please try again later.");
      setResearchPapers([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDigest(selectedMonth);
  }, [selectedMonth]);

  return (
    <div className="min-h-screen bg-[#f7f9fc] text-[#333] font-sans">
      {/* Header */}
      <header className="text-center py-8 md:py-12 px-4 sm:px-6 bg-white shadow-sm border-b border-[#e5e7eb]">
        <h1 className="text-3xl sm:text-4xl font-bold text-[#a41e22]">
          DTU Research Digest
        </h1>
        <p className="text-[#555] mt-2 sm:mt-3 max-w-2xl mx-auto text-base sm:text-lg">
          Explore faculty research highlights and publications from across DTU —
          curated monthly.
        </p>
      </header>

      {/* Month Selector */}
      <section className="max-w-5xl mx-auto px-4 sm:px-6 mt-8 sm:mt-10">
        <div className="flex flex-col items-center gap-2 sm:gap-3">
          <label className="text-sm sm:text-md font-medium text-[#a41e22]">
            Select Month
          </label>
          <select
            value={selectedMonth}
            onChange={(e) => setSelectedMonth(Number(e.target.value))}
            className="w-full sm:w-auto bg-white border border-[#ccc] text-[#333] py-2 px-4 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-[#a41e22]"
          >
            {monthOptions.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>
      </section>

      {/* Research Papers */}
      <section className="max-w-6xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
        {loading ? (
          <p className="text-center text-[#a41e22] text-lg font-medium">
            Loading...
          </p>
        ) : error ? (
          <p className="text-center text-red-600 text-lg font-medium">
            {error}
          </p>
        ) : researchPapers.length === 0 ? (
          <p className="text-center text-[#888] text-lg">
            No research found for this month.
          </p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {researchPapers.map((paper, index) => (
              <div
                key={index}
                className="bg-white p-4 sm:p-6 rounded-xl shadow-md hover:shadow-lg transition duration-300 border border-[#e5e7eb] relative"
              >
                <span className="inline-block text-xs bg-[#820000] text-white px-2.5 py-1 rounded-full shadow-sm font-medium mb-3 sm:mb-4">
                  {paper.paper_type}
                </span>
                <h3 className="text-base sm:text-lg font-semibold text-[#a41e22] mb-2">
                  {paper.title_of_paper}
                </h3>

                <p className="text-xs sm:text-sm text-[#374151] mb-1">
                  <strong>Authors:</strong> {paper.authors}
                </p>
                <p className="text-xs sm:text-sm text-[#374151] mb-1">
                  <strong>Area:</strong> {paper.area_of_research}
                </p>
                <p className="text-xs sm:text-sm text-[#374151] mb-1">
                  <strong>Published In:</strong> {paper.name_of_publication}
                </p>
                <p className="text-xs sm:text-sm text-[#6b7280] mt-2">
                  <strong>ISSN:</strong> {paper.ISSN_number}
                </p>
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
};

export default ResearchDigestPage;
